import PermissionDenied from './PermissionDenied';

export default PermissionDenied;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PermissionDenied/index.js